import React from "react";

const Java_DataTypes_Numbers = () => {
  return (
    <div>
      <h1>Java DataTypes Numbers</h1>
      <p>This page provides explanations, examples, and common use-cases for Java DataTypes Numbers in Java.</p>
    </div>
  );
};

export default Java_DataTypes_Numbers;
